import { createContext, useCallback, useContext, useState } from 'react';

const HostStockPromoContext = createContext();

const initialState = {
  selectedTab: 'stok',
  selectedDetailPromo: null,
  selectedDetailStock: null,
  stockFilterDrawerOpen: false,
  promoFilterDrawerOpen: false,
  previousStocks: [],
  previousPromotions: [],
  showTopBar: true,
  showScrollToTop: false,
};

const initialFilterState = {
  limit: 10,
  page: 1,
  search: '',
  brandId: [],
  store: [],
  stockStatus: [],
  promoStatus: [],
};

const HostStockPromoProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = useCallback((payload) => setState((prev) => ({ ...prev, ...payload })), []);
  const updateFilterState = useCallback((payload) => setFilterState((prev) => ({ ...prev, ...payload })), []);

  return <HostStockPromoContext.Provider value={{ updateFilterState, filterState, updateState, state }}>{children}</HostStockPromoContext.Provider>;
};

export const useHostStockPromoState = () => {
  return useContext(HostStockPromoContext);
};

export default HostStockPromoProvider;
